module.exports = __webpack_public_path__ + "static/media/logo.e2c7d9d8.svg";